"use client";

import { CloudXIcon } from "@phosphor-icons/react/dist/csr/CloudX";
import { Spinner } from "design-system/spinner";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

export function LoadValue({
  loadingValue,
  showValue = false,
  spinnerClassname,
  value,
  wrapperClassname,
}: {
  loadingValue?: React.ReactNode;
  showValue: boolean;
  spinnerClassname?: string;
  value: React.ReactNode;
  wrapperClassname?: string;
}) {
  const [hasTimedOut, setHasTimedOut] = useState(false);

  useEffect(() => {
    if (!showValue) {
      const timeoutId = setTimeout(() => {
        setHasTimedOut(true);
      }, 7000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [showValue]);

  if (showValue) {
    return value;
  }

  return (
    <div className={cn("flex h-5 flex-row items-center justify-start gap-2", wrapperClassname)}>
      {!showValue && hasTimedOut ? (
        <CloudXIcon className={cn("size-5", spinnerClassname)} />
      ) : (
        <>
          <Spinner className={cn("size-5", spinnerClassname)} />
          {loadingValue && <span>{loadingValue}</span>}
        </>
      )}
    </div>
  );
}
